document.addEventListener('DOMContentLoaded', function () {
    if (window.innerWidth <= 989) {
        document.querySelectorAll('.heading-container').forEach(heading => {
            heading.addEventListener('click', () => {
                heading.parentNode.classList.toggle('active');
                for (const sibling of heading.parentNode.parentNode.children) {
                    if (sibling !== heading.parentNode) sibling.classList.remove('active');
                }
            });
        });
    }
});